import Box from '@/common/components/Box'
import Skeleton from '@/common/components/Skeleton'

export const FeeDetailsSectionLoadingState = () => {
  return (
    <Box className="p-4 flex flex-col gap-y-4">
      <div className="flex items-center gap-x-3">
        <Skeleton width={75} height={34} className="bg-white-100" />

        <Skeleton width={120} height={28} />
      </div>

      <Skeleton width={96} />

      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="flex items-center gap-x-4">
          <div className="flex items-center gap-x-2">
            <Skeleton width={20} height={20} circle className="bg-white-100" />

            <div className="flex flex-col gap-y-0.5">
              <Skeleton width={76} height={12} />

              <Skeleton width={120} height={16} />
            </div>
          </div>

          <div className="flex items-center gap-x-2">
            <Skeleton width={20} height={20} circle className="bg-white-100" />

            <div className="flex flex-col gap-y-0.5">
              <Skeleton width={24} height={12} />

              <Skeleton width={56} height={16} />
            </div>
          </div>
        </div>
      ))}
    </Box>
  )
}
